import type { StructuredSearchTrack } from '@core/Areas/StructuredSearch/types'

export function getFilteredTracks(
  availableTracks: StructuredSearchTrack[] | null,
  selectedTracks: string[]
): StructuredSearchTrack[] {
  let tracks: StructuredSearchTrack[] = []

  if (selectedTracks && availableTracks) {
    tracks = []
    selectedTracks.forEach(selectedTrack => {
      availableTracks.forEach(availableTrack => {
        if (availableTrack.id === selectedTrack) {
          tracks?.push(availableTrack)
        }
      })
    })
  }

  return tracks
}
